const loadImage = (image) => {
  if (image.dataset.vicsDeferredSrc) {
    image.src = image.dataset.vicsDeferredSrc;
    delete image.dataset.vicsDeferredSrc;
  }
};
const init = (root = document) => {
  const images = root.querySelectorAll('img[data-vics-deferred-src]');
  if (!('IntersectionObserver' in window)) { images.forEach(loadImage); return; }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      loadImage(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '400px 0px' });
  images.forEach(image => observer.observe(image));
};
init();
document.addEventListener('shopify:section:load', event => init(event.target));
